import React from 'react';
import PropTypes from 'prop-types';
import { styled } from '@uhg-abyss/web/tools/styled';
import { event } from '@uhg-abyss/web/tools/event';
import { isDownloadLink } from '../UHCUpdates';
import { Link } from '@uhg-abyss/web/ui/Link';

const StyledTitle = styled('label', {
  color: '$primary1',
  fontSize: '20px',
  fontWeight: '700',
  minWidth: 150,
});

const StyledContent = styled('p', {
  width: '90%',
  margin: 0,
});

const StyledLink = styled(Link, {
  '&.abyss-link-icon-wrapper': {
    display: 'none',
  },
  marginTop: '10px',
});

const StyledStack = styled('div', {
  width: '90%',
  margin: '16px 0',

  flexDirection: 'column',
  justifyContent: 'center',
});

export const InfoCard = ({
  title,
  description,
  link,
  linkText,
  isDownload,
  downloadContext,
  dataTestid,
}) => {
  const displayText = linkText || 'Read more';
  const sendDownloadClick = isDownloadLink(link, isDownload);

  const fireSharedAnalytics = (interactionEvent) => {
    // Download specific analytics
    if (sendDownloadClick) {
      event('DOWNLOAD_CLICK', {
        fileName: displayText,
        fileURL: link,
        fileType: downloadContext,
      });
    }
    // Card interaction analytics
    event(interactionEvent, {
      interactionName: title,
      interactionValue: displayText,
    });
    // Exit link analytics (skip when download analytics already represent it)
    if (!sendDownloadClick) {
      event('EXIT_LINK_NAVIGATE', { linkText: displayText, linkUrl: link });
    }
  };

  const handleLinkClick = (e) => {
    if (!link) return;
    if (window.innerWidth >= 984) {
      fireSharedAnalytics('RIGHT_RAIL_LINK_CLICK');
    } else {
      fireSharedAnalytics('RIGHT_RAIL_MOBILE_WIDGET_CLICK');
    }
  };

  return (
    <StyledStack data-testid="styled-stack">
      <StyledTitle>{title}</StyledTitle>
      <StyledContent>{description}</StyledContent>
      <span>
        <StyledLink
          href={link}
          target="_blank"
          rel="noopener noreferrer"
          onClick={handleLinkClick}
          data-testid={dataTestid}
          css={{ width: 'auto' }}
        >
          {displayText}
        </StyledLink>
      </span>
    </StyledStack>
  );
};

InfoCard.propTypes = {
  title: PropTypes.string,
  description: PropTypes.string,
  linkText: PropTypes.string,
  link: PropTypes.string,
  isDownload: PropTypes.bool,
  downloadContext: PropTypes.string,
  dataTestid: PropTypes.string,
};

InfoCard.defaultProps = {
  title: '',
  description: '',
  linkText: '',
  link: '',
  isDownload: false,
  downloadContext: '',
  dataTestid: '',
};
